module.exports = __webpack_public_path__ + "fonts/IstokWeb-Bold.c0844ccd.eot";